import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { FormDialog } from "@/components/kids/kidsUi";
import { ACCEPT, checkFile, uploadFile } from "@/lib/upload13";

export function ServiceDialog({ base, v, s, today, onClose, onSaved }) {
  const [f, setF] = useState({ date: s?.date || today, mileage: s?.mileage ?? v.odometer, schedule_key: s?.schedule_key || "oil", service: s?.schedule_key ? "" : s?.service || "",
    shop: s?.shop || "", cost: s?.cost || "", notes: s?.notes || "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, val) => setF((x) => ({ ...x, [k]: val }));
  const save = async () => {
    if (file && checkFile(file)) { toast.error(checkFile(file)); return; }
    setBusy(true);
    try {
      const receipt_upload_id = file ? await uploadFile(base, file) : null;
      const body = { ...f, mileage: Number(f.mileage), cost: f.cost === "" ? null : Number(f.cost), schedule_key: f.schedule_key || null, receipt_upload_id };
      const { data } = s ? await api.put(`${base}/${v.id}/services/${s.id}`, body) : await api.post(`${base}/${v.id}/services`, body);
      toast.success("Service logged"); onSaved(data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const inp = (k, l, t = "text") => <Field label={l}><input type={t} className="q-input min-h-[44px] w-full" value={f[k]} onChange={(e) => set(k, e.target.value)} data-testid={`service-${k}`} /></Field>;
  return (
    <FormDialog open onClose={onClose} title={s ? "Edit service" : "Log a service"} description="A cost goes into Spending once as Car. The receipt is filed in Documents → Vehicle." testid="service-dialog">
      <div className="space-y-3">
        <Field label="Service"><select className="q-input min-h-[44px] w-full" value={f.schedule_key} onChange={(e) => set("schedule_key", e.target.value)} data-testid="service-schedule">
          {v.schedules.map((x) => <option key={x.key} value={x.key}>{x.name}</option>)}<option value="">Other…</option></select></Field>
        {!f.schedule_key && inp("service", "What was done")}
        <div className="grid grid-cols-2 gap-3">{inp("date", "Date", "date")}{inp("mileage", "Mileage", "number")}{inp("shop", "Shop")}{inp("cost", "Cost ($)", "number")}</div>
        {inp("notes", "Notes")}
        <Field label="Receipt (optional)"><input type="file" accept={ACCEPT} className="q-input min-h-[44px] w-full" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="service-receipt" /></Field>
        <button className="q-btn q-btn-primary min-h-[44px] w-full" disabled={busy} onClick={save} data-testid="service-save">{busy ? "Saving…" : "Save"}</button>
      </div>
    </FormDialog>
  );
}

export function OdometerDialog({ base, v, onClose, onSaved }) {
  const [m, setM] = useState(v.odometer);
  const [err, setErr] = useState("");
  const save = () => api.put(`${base}/${v.id}/odometer`, { miles: Number(m) }).then(({ data }) => { toast.success("Odometer updated"); onSaved(data); }).catch((e) => setErr(errMsg(e)));
  return (
    <FormDialog open onClose={onClose} title="Update odometer" testid="odometer-dialog">
      <div className="space-y-3">
        <Field label="Miles"><input type="number" className="q-input min-h-[44px] w-full" value={m} onChange={(e) => { setM(e.target.value); setErr(""); }} data-testid="odometer-input" /></Field>
        {err && <p className="q-error" data-testid="odometer-error">{err}</p>}
        <button className="q-btn q-btn-primary min-h-[44px] w-full" onClick={save} data-testid="odometer-save">Save</button>
      </div>
    </FormDialog>
  );
}

export function ScheduleDialog({ base, v, s, onClose, onSaved }) {
  const [f, setF] = useState({ every_miles: s.every_miles || "", every_months: s.every_months || "", last_miles: s.last_miles ?? "", last_date: s.last_date || "" });
  const set = (k, val) => setF((x) => ({ ...x, [k]: val }));
  const num = (x) => (x === "" ? null : Number(x));
  const save = () => api.put(`${base}/${v.id}/schedules/${s.key}`, { every_miles: num(f.every_miles), every_months: num(f.every_months), last_miles: num(f.last_miles), last_date: f.last_date || null })
    .then(({ data }) => { toast.success("Schedule saved"); onSaved(data); }).catch((e) => toast.error(errMsg(e)));
  const inp = (k, l, t = "number") => <Field label={l}><input type={t} className="q-input min-h-[44px] w-full" value={f[k]} onChange={(e) => set(k, e.target.value)} data-testid={`schedule-${k}`} /></Field>;
  return (
    <FormDialog open onClose={onClose} title={s.name} description="Due at whichever comes first." testid="schedule-dialog">
      <div className="space-y-3">
        <div className="grid grid-cols-2 gap-3">{inp("every_miles", "Every (miles)")}{inp("every_months", "Every (months)")}{inp("last_miles", "Last done at (mi)")}{inp("last_date", "Last done on", "date")}</div>
        <button className="q-btn q-btn-primary min-h-[44px] w-full" onClick={save} data-testid="schedule-save">Save</button>
      </div>
    </FormDialog>
  );
}
